Application.Signature.WallpaperEditor = {
    ui: {
        container: '.js-wallpaper-editor.step-wallpaper-editor',
        previewContainer: '.step-wallpaper-editor__preview',
        previewBlock: '.step-wallpaper-editor__preview .preview',
        previewContent: '.preview__content',
        previewLogo: '.preview__logo',
        formatToggle: '.step-wallpaper-editor__format-input input',
        inputSettings: '.step-preview__settings-input'
    },
    previewList: null,
    state: {
        transformed: false,
        format: null,
        x: null,
        y: null,
        width: null
    },
    ready: function (previewList) {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        // assign
        this.previewList = previewList;

        // children
        this.Transformer.ready(this);
        // this.Mover.ready(this);

        // bind handlers
        this.bind();

        // init icon state
        // self.toggleFormat($(this.ui.formatToggle).filter(':checked').val());

    },
    bind: function(){

        var self = this;

        // get element references
        var $content = $(this.ui.previewContent);
        var $logo = $(this.ui.previewLogo);

        // update logo position when ready
        this.previewList.setOnReady(function(){
            if($logo.data('width')){
                self.Transformer.setPosition($logo.data('x') * $content.width() / 100, $logo.data('y') * $content.outerHeight() / 100, $logo.data('width') * $content.width() / 100);
                self.state.transformed = true;
            }
        });
        // update background when requested
        this.previewList.setOnChange(function(id, src, data){
            // change background
            self.background(id, src, function(){
                // when background loaded
                self.Transformer.setColorRestriction(data.colorRestriciton ? data.colorRestriciton : false, src);
                if (!self.state.transformed || data.colorRestriciton || !self.Transformer.isCurrentPositionValid()){
                    // if format is not set yet, use the radio value (this happens on first call)
                    var format = self.state.format ? self.state.format : $(self.ui.formatToggle).filter(':checked').val();
                    // when resetting the position, place the full logo and only then calculate the position of a partial format
                    self.toggleFormat(format, function(){
                        var x = data.iconX * $content.width() / 100
                        var y = data.iconY * $content.outerHeight() / 100;
                        var width = data.iconWidth * $content.width() / 100;
                        self.Transformer.setPosition(x, y, width);
                    });
                }
            });
        });
        // update transformer scaling on zoom
        this.previewList.setOnZoom(function(multiplier){
            self.scale(multiplier);
            // self.Mover.reset();
        });

        // update icon state
        $(this.ui.formatToggle).change(function (e) {
            self.toggleFormat($(this).filter(':checked').val());
        });

        // transformer
        this.Transformer.on('move', function(x, y){
            self.move(x, y);
        });
        this.Transformer.on('resize', function(x, y, w, h){
            self.resize(x, y, w, h);
        });

    },
    background: function(id, src, onloaded){

        var self = this;

        // load the image
        $('<img/>').attr('src', src).on('load', function() {
            // prevent memory leaks
            $(this).remove();
            // change background
            $(self.ui.previewContent).css('background-image', 'url(' + src + ')');
            // loaded callback
            if (typeof onloaded == 'function') {
                onloaded();
            }
        });

    },
    scale: function(m){

        // this.Transformer.setScale(m);
        // this.Mover.setScale(m);

    },
    move: function(x, y){

        var $content = $(this.ui.previewContent);

        // update input settings
        this.state.x = x * 100 / $content.outerWidth();
        this.state.y = y * 100 / $content.outerHeight();
        this.state.transformed = true;
        this.updateInput();

    },
    resize: function(x, y, w){

        var $content = $(this.ui.previewContent);

        // move
        this.move(x, y);

        // update input settings
        this.state.width = w * 100 / $content.outerWidth();
        this.state.transformed = true;
        this.updateInput();

    },
    toggleFormat: function(format, callback){

        // always change back to full first
        switch (this.state.format) {
            case 'name':
                this.resizeFromName();
                break;
            case 'icon':
                this.resizeFromIcon();
                break;
        }

        // save current state
        this.state.format = format;

        // run the callback
        if (typeof callback === 'function'){
            callback();
        }

        // resize or show / hide
        switch (format) {
            case 'full':
                this.showLogo();
                this.validatePosition();
                break;
            case 'name':
                this.showLogo();
                this.resizeToName();
                break;
            case 'icon':
                this.showLogo();
                this.resizeToIcon();
                break;
            case 'background':
                this.hideLogo();
                break;
        }

        // update input
        this.updateInput();

    },
    resizeFromName: function(){

        // retrieve data
        var $content = $(this.ui.previewContent);
        var wordmarkWidthRatio = parseFloat($(this.ui.previewLogo).data('wordmark-width-ratio'));
        var wordmarkHeightRatio = parseFloat($(this.ui.previewLogo).data('wordmark-height-ratio'));
        var wordmarkHeight = $(this.Transformer.ui.transformerImg).height();

        // update state
        $(this.ui.previewBlock).removeClass('preview_wordmark');

        // recalculate width
        this.state.width = this.state.width / wordmarkWidthRatio;

        // resize and move
        var y = parseFloat($(this.Transformer.ui.transformer).css('top'));
        var newY = y - wordmarkHeight * (1 - wordmarkHeightRatio) / wordmarkHeightRatio;
        this.Transformer.setPosition(this.state.x * $content.width() / 100, newY, this.state.width * $content.width() / 100);

    },
    resizeFromIcon: function(){

        // retrieve data
        var $content = $(this.ui.previewContent);
        var iconWidthRatio = parseFloat($(this.ui.previewLogo).data('icon-width-ratio'));
        var iconHeightRatio = parseFloat($(this.ui.previewLogo).data('icon-height-ratio'));
        var iconWidth = $(this.Transformer.ui.transformerImg).width();
        var iconHeight = $(this.Transformer.ui.transformerImg).height();

        // update state
        $(this.ui.previewBlock).removeClass('preview_icon');

        // recalculate width
        this.state.width = this.state.width / iconWidthRatio;

        // resize and move
        var x = parseFloat($(this.Transformer.ui.transformer).css('left'));
        var newX = x - iconWidth * (1 - iconWidthRatio) / iconWidthRatio;
        var y = parseFloat($(this.Transformer.ui.transformer).css('top'));
        var newY = y - iconHeight * (0.89131 /* the icon is not placed at the bottom */ - iconHeightRatio) / iconHeightRatio;
        this.Transformer.setPosition(newX, newY, this.state.width * $content.width() / 100);

    },
    resizeToName: function(){

        // retrieve data
        var $content = $(this.ui.previewContent);
        var wordmarkWidthRatio = parseFloat($(this.ui.previewLogo).data('wordmark-width-ratio'));
        var wordmarkHeightRatio = parseFloat($(this.ui.previewLogo).data('wordmark-height-ratio'));
        var logoHeight = $(this.Transformer.ui.transformerImg).height();

        // update state
        $(this.ui.previewBlock).addClass('preview_wordmark');

        // recalculate width
        this.state.width = this.state.width * wordmarkWidthRatio;

        // resize and move
        var y = parseFloat($(this.Transformer.ui.transformer).css('top'));
        var newY = y + logoHeight * (1 - wordmarkHeightRatio);
        this.Transformer.setPosition(this.state.x * $content.width() / 100, newY, this.state.width * $content.width() / 100);

        // move, if out of bounds
        this.validatePosition();

    },
    resizeToIcon: function(){

        // retrieve data
        var $content = $(this.ui.previewContent);
        var iconWidthRatio = parseFloat($(this.ui.previewLogo).data('icon-width-ratio'));
        var iconHeightRatio = parseFloat($(this.ui.previewLogo).data('icon-height-ratio'));
        var logoWidth = $(this.Transformer.ui.transformerImg).width();
        var logoHeight = $(this.Transformer.ui.transformerImg).height();

        // update state
        $(this.ui.previewBlock).addClass('preview_icon');

        // recalculate width and height and x and y
        // width
        this.state.width = this.state.width * iconWidthRatio;
        // x
        var x = parseFloat($(this.Transformer.ui.transformer).css('left'));
        var newX = x + logoWidth * (1 - iconWidthRatio);
        // y
        var y = parseFloat($(this.Transformer.ui.transformer).css('top'));
        var newY = y + logoHeight * (0.89131 /* the icon is not placed at the bottom */ - iconHeightRatio);
        // reposition
        this.Transformer.setPosition(newX, newY, this.state.width * $content.width() / 100);

        // move, if out of bounds
        this.validatePosition();

    },
    validatePosition: function(){

        // move, if out of bounds
        var movable = this.Transformer.move(0, 0);
        this.Transformer.moveCommit();
        if (!this.Transformer.isCurrentPositionValid()){
            // if the icon can't be moved to a valid place in its current size, reset it to the default position
            this.previewList.reloadIcon();
        }

    },
    hideLogo: function(){

        // update state
        $(this.ui.previewBlock).addClass('preview_background-only');

    },
    showLogo: function(){

        // update state
        $(this.ui.previewBlock).removeClass('preview_background-only');

    },
    updateInput: function(){

        $(this.ui.inputSettings).val(JSON.stringify(this.getSettings()));

    },
    getSettings: function () {

        return {
            x: this.state.x,
            y: this.state.y,
            format: this.state.format,
            width: this.state.width,
        };

    }
};